import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { ContextData } from '../../../../context/Context';
import { Getrequest } from '../../../../context/AxiosRequest';
import { over } from 'lodash';
import GetAdminCredentials from '../../../../context/GetAdminCredentials';
import SeePerson from './SeePerson';


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    maxHeight: 500,
    width: "100%",
    overflowY: 'auto',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

export default function WorkflowNote({applicant_token}) {




      const [content, setContent] = React.useState(null);
      const {accesstoken,userToken} = React.useContext(ContextData);

      React.useEffect(() => {
        // Fetch rejection notes from the server
        const fetchRejectionNotes = async () => {

                  const response = await Getrequest(`/auth/get_mssg_notfier/${applicant_token}`,accesstoken);
                  setContent(response);

                  
                     

        };    
    
        fetchRejectionNotes();  
      }, [applicant_token, accesstoken]);





  return (
    <div >
   
      <HtmlTooltip
        title={
          <React.Fragment>
            
            <Typography color="inherit">WorkFlow Notes </Typography>
            <Typography sx={{ fontSize: 12 }}>{!content && "No Rejection Notes Available"}</Typography>
               {
                content && content.map((item,index)=>(
                  <div key={index} className='border-solid border-[1px]  border-gray-300 rounded-md p-3 mb-3  text-white flex flex-col justify-center items-start'>
                       
                       {
                        item.mssg_body ?
                     <div className='bg-gray-200 w-[100%] text-black rounded-md px-2 py-1 mb-2'>
                      <p className='flex justify-center items-center'><strong>{item.mssg_subject}</strong></p>
                      <p className='p-3'>{item.mssg_body}</p> 
                      <p>Date: <small>{item.createdAtDate}</small></p>
                      <p>Time: <small>{item.createdAtTime}</small></p>
                       <SeePerson senderToken={item.sender_token} /> 
                       </div>
                       :
                       <p className='text-black'>No Message</p>
                       }
                    
                </div>
                ))
               }
          </React.Fragment>
        }
      >
        <Button sx={{backgroundColor:"purple" , marginLeft:"1em"}} variant='contained'>Internal</Button>
      </HtmlTooltip>
    </div>
  );
}
